<script>

</script>

<template>
  <header class="main-header">
    <div class="notification-bar">
      <div class="notification-bar--first_line">
        <span class="small-text">Sie haben Fragen?&nbsp;</span>
        <span class="small-text">Kontaktieren Sie uns gern</span>
      </div>
      <a class="notification-bar__telephone" href="tel:+49 800 3233800"><span class="small-text">Telefonisch +49 800 3233800</span></a>
    </div>
    <div class="main-header--wrapper">
      <div class="main-header--left"></div>
      <div class="main-header--right">
        <a href="https://www.johanniter.de/dienste-leistungen/pflege-und-begleitung/hausnotruf/" class="back-to-home">
          <span class="large-text"> &lt; Zur Webseite</span>
        </a>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import '~brandVariables/variables.scss';
// Set a fallback value for $secondary-color if it's not defined
$secondary-color: #eb003c !default;

.main-header {
  width: 100%;
  height: 150px;
  background: $secondary-color;

  .notification-bar {
    background: $main-color;
    height: 60px;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;

    span.small-text {
      font-size: 14px;
      line-height: 14.40px;
    }

    .notification-bar--first_line {
      display: flex;
    }
    .notification-bar__telephone {
      text-decoration: none;
      color: white;
    }
  }

  .main-header--wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 0 10px;

    .main-header--left {
      width: 125px;
      height: 88px;
      background-image: url('../assets/img/Johanniter_logo_header.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .main-header--right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: right;

      span {
        color: white;
        word-wrap: break-word;
        font-weight: 500;
      }

      .large-text {
        font-size: 14px;
        line-height: 14.40px;
      }
    }

    a.back-to-home {
      text-decoration: none;
    }
  }
  .main-header-announcement-wrapper {
    background-color: #deff00;

    .main-header-announcement {
      height: 50px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      span {
        font-size: 12px;
        font-weight: 900;
        text-shadow: 0.1px 0 black;
      }

    }
  }
}

</style>
